module.exports = __webpack_public_path__ + "img/7465130.svg";